import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VContainer,
        { attrs: { fluid: "" } },
        [
          _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      _vm._s(_vm.$t("form_attrs_use_case.sandbox_project"))
                    ),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "4" } },
                [
                  _c(VTextField, {
                    attrs: {
                      filled: "",
                      readonly: "",
                      "hide-details": "auto",
                      dense: "",
                    },
                    model: {
                      value: _vm.item.project_sand,
                      callback: function ($$v) {
                        _vm.$set(_vm.item, "project_sand", $$v)
                      },
                      expression: "item.project_sand",
                    },
                  }),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      _vm._s(_vm.$t("form_attrs_use_case.sandbox_dataset"))
                    ),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "4" } },
                [
                  _c(VTextField, {
                    attrs: {
                      filled: "",
                      readonly: "",
                      "hide-details": "auto",
                      dense: "",
                    },
                    model: {
                      value: _vm.item.dataset_sand,
                      callback: function ($$v) {
                        _vm.$set(_vm.item, "dataset_sand", $$v)
                      },
                      expression: "item.dataset_sand",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            { staticClass: "mt-2", attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      _vm._s(_vm.$t("form_attrs_use_case.generated_views"))
                    ),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9" } },
                [
                  _c(
                    VList,
                    _vm._l(_vm.item.views, function (view) {
                      return _c(
                        VListItem,
                        { key: view.name },
                        [
                          _c(
                            VListItemAvatar,
                            [_c(VIcon, [_vm._v("mdi-table-plus")])],
                            1
                          ),
                          _c(
                            VListItemContent,
                            [
                              _c(VListItemTitle, {
                                domProps: { textContent: _vm._s(view.name) },
                              }),
                            ],
                            1
                          ),
                          _c(
                            VListItemAction,
                            { staticClass: "d-flex flex-row" },
                            [
                              _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              VBtn,
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: { icon: "" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.copyViewId(
                                                          view.name
                                                        )
                                                      },
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(VIcon, [
                                                  _vm._v("icon-copy"),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("botones.boton_copiar"))
                                    ),
                                  ]),
                                ]
                              ),
                              view.type === "external"
                                ? _c(
                                    VTooltip,
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  VBtn,
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: { icon: "" },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openDeleteDialog(
                                                              view.name
                                                            )
                                                          },
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(VIcon, [
                                                      _vm._v("icon-delete"),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("botones.boton_eliminar")
                                          )
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.item.partyid_match
            ? _c(
                VRow,
                { staticClass: "mt-2", attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "3", lg: "2" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.$t("form_attrs_use_case.filter"))),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "9" } },
                    [
                      _c(
                        VListItem,
                        [
                          _c(
                            VListItemAvatar,
                            [_c(VIcon, [_vm._v("mdi-table")])],
                            1
                          ),
                          _c(
                            VListItemContent,
                            [
                              _c(VListItemTitle, {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.item.partyid_match.table_id
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("dialog-confirmation-component", {
        ref: _vm.DIALOG_DELETE,
        attrs: {
          title: "Confirmación de Eliminación",
          text: "¿Estás seguro de eliminar esta base?",
          width: 450,
        },
        on: { onConfirm: _vm.deleteBase },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }